var React = require('react');

function IconCommodityElectric (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 7.00751C11 6.85735 10.985 5.02038 10.985 5.02038C10.985 4.74508 10.7548 4.51984 10.4797 4.51984H9.50907V0.500536C9.50907 0.225241 9.28393 0 9.00876 0H8.50844C8.23327 0 8.00813 0.225241 8.00813 0.500536V4.51984H6.00688V0.500536C6.00688 0.225241 5.78174 0 5.50657 0H5.00625C4.73108 0 4.50594 0.225241 4.50594 0.500536V4.51984H3.50031C3.22514 4.51984 3 4.74508 3 5.02038V6.49696C3 6.77226 3 6.9975 3 6.9975V7.0025C3 7.0025 3 7.0025 3 7.00751C3 9.0547 4.53596 10.7415 6.5172 10.9818V13.4995C6.5172 13.7748 6.74234 14 7.01751 14C7.29268 14 7.51782 13.7748 7.51782 13.4995V10.9768C9.48906 10.7215 11 9.04469 11 7.00751Z"}));
}

IconCommodityElectric.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = IconCommodityElectric;

IconCommodityElectric.default = IconCommodityElectric;
